import { MantineProvider } from '@mantine/core'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import ReactDOM from 'react-dom/client'
import '@mantine/core/styles.css'
import '@/style/global.css'
import { cssVariablesResolver, theme } from '@/style/theme'
import { App } from './app/App.tsx'

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 0,
        },
    },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
    <MantineProvider theme={theme} cssVariablesResolver={cssVariablesResolver}>
        <QueryClientProvider client={queryClient}>
            <App />
        </QueryClientProvider>
    </MantineProvider>
)
